import Box from "@mui/material/Box";
import { colors } from "@/theme/colors";
import { GRAIN_TEXTURE } from "@/theme/texture";

/** Three large blurred washes that drift behind the assistant — violet,
 *  slate, and green light over cool paper. Pure CSS; stilled under
 *  reduced motion. */
const blob = {
  position: "absolute",
  borderRadius: "50%",
  filter: "blur(110px)",
  pointerEvents: "none",
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
} as const;

/**
 * The backdrop for the full-screen assistant: drifting washes of warm light
 * and a fine grain overlay over the paper canvas. Decorative only.
 */
export function AuroraBackdrop() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        "@keyframes auroraA": {
          "0%, 100%": { transform: "translate(0,0) scale(1)" },
          "50%": { transform: "translate(8vw, 6vh) scale(1.15)" },
        },
        "@keyframes auroraB": {
          "0%, 100%": { transform: "translate(0,0) scale(1)" },
          "50%": { transform: "translate(-7vw, -5vh) scale(1.1)" },
        },
        "@keyframes auroraC": {
          "0%, 100%": { transform: "translate(0,0) scale(1)" },
          "50%": { transform: "translate(5vw, -8vh) scale(1.08)" },
        },
      }}
    >
      <Box
        sx={{
          ...blob,
          width: "46vw",
          height: "46vw",
          top: "-12%",
          left: "-6%",
          backgroundColor: colors.primary,
          opacity: 0.12,
          animation: "auroraA 24s ease-in-out infinite",
        }}
      />
      <Box
        sx={{
          ...blob,
          width: "40vw",
          height: "40vw",
          bottom: "-14%",
          right: "-4%",
          backgroundColor: colors.secondary,
          opacity: 0.1,
          animation: "auroraB 28s ease-in-out infinite",
        }}
      />
      <Box
        sx={{
          ...blob,
          width: "34vw",
          height: "34vw",
          top: "30%",
          right: "22%",
          backgroundColor: colors.success,
          opacity: 0.06,
          animation: "auroraC 32s ease-in-out infinite",
        }}
      />
      {/* Grain overlay. */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: GRAIN_TEXTURE,
          backgroundRepeat: "repeat",
          opacity: 0.045,
          mixBlendMode: "overlay",
        }}
      />
    </Box>
  );
}
